

export class FuelStationUpdateInput implements IFuelStationUpdateInput {
    /** The auto-generated id of the fuel station master */
    fuelStationId!: number;
    /** The fuel station name with 255 character limit */
    fuelStationName!: string;

    constructor(data?: IFuelStationUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelStationId = _data["fuelStationId"];
            this.fuelStationName = _data["fuelStationName"];
        }
    }

    static fromJS(data: any): FuelStationUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new FuelStationUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelStationId"] = this.fuelStationId;
        data["fuelStationName"] = this.fuelStationName;
        return data; 
    }
}

export interface IFuelStationUpdateInput {
    /** The auto-generated id of the fuel station master */
    fuelStationId: number;
    /** The fuel station name with 255 character limit */
    fuelStationName: string;
}

